<template>
	<view class="box">
		<view class="box-head" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
			<view class="box-head-info">
				<text>货运认证</text>
				<text>请按要求填写认证信息</text>
			</view>
			<view class="box-head-content">
				<view class="item">
					<view class="item-label">
						<text>认证类型</text>
						<text>*</text>
					</view>
					<view class="item-cate">
						<view class="item-cate-row active">个人</view>
						<view class="item-cate-row">企业</view>
					</view>
				</view>
				<view class="item">
					<view class="item-label">
						<text>联系人</text>
						<text>*</text>
					</view>
					<view class="item-val">
						<input type="text" placeholder="请输入真实姓名" />
					</view>
				</view>
				<view class="item">
					<view class="item-label">
						<text>单位名称</text>
						<text>*</text>
					</view>
					<view class="item-val">
						<input type="text" placeholder="请输入单位名称" />
					</view>
				</view>
				<view class="item">
					<view class="item-label">
						<text>手机号</text>
						<text>*</text>
					</view>
					<view class="item-val">
						<text>点击获取</text>
						<button open-type="getPhoneNumber">获取手机号</button>
					</view>
				</view>
				<view class="item">
					<view class="item-label">
						<text>接单位置</text>
						<text>*</text>
					</view>
					<view class="item-val">
						<text>请选择</text>
						<u-icon name="arrow-right" color="#111111" size="18"></u-icon>
					</view>
				</view>
				<view class="item">
					<view class="item-label">
						<text>认证资料</text>
						<text>*</text>
					</view>
					<view class="item-upload">
						<view class="item-upload-item">
							<view class="image">
								<image src="/static/icon/ic_camera@2x.png" mode="widthFix"></image>
								<text>点击上传</text>
							</view>
							<view class="info">
								<text>营业执照</text>
								<text>*</text>
							</view>
						</view>
						<view class="item-upload-item">
							<view class="image">
								<image src="/static/icon/ic_camera@2x.png" mode="widthFix"></image>
								<text>点击上传</text>
							</view>
							<view class="info">
								<text>道路运输经营许可证</text>
								<text>*</text>
							</view>
						</view>
						<view class="item-upload-item">
							<view class="image">
								<image src="/static/icon/ic_camera@2x.png" mode="widthFix"></image>
								<text>点击上传</text>
							</view>
							<view class="info">
								<text>其它认证资料</text>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view class="box-head-botton">提交认证</view>
			<view style="width: 100%; height: calc(30rpx + env(safe-area-inset-bottom));"></view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				bgImg: require('@/static/image/bg_renzheng_huoyun@2x.png')
			};
		}
	}
</script>

<style>
	page {
		background-color: #F7F7F7;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box-head {
			width: 100%;
			height: 300rpx;
			padding: 34rpx 40rpx 0 40rpx;
			box-sizing: border-box;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			.box-head-botton {
				width: 100%;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
				background: #00BC12;
				border-radius: 44rpx;
				margin-top: 30rpx;
			}
			.box-head-info {
				width: 100%;
				display: flex;
				flex-direction: column;
				text {
					&:nth-child(1) {
						font-weight: bold;
						font-size: 48rpx;
						color: #FFFFFF;
					}
					&:nth-child(2) {
						font-weight: 400;
						font-size: 26rpx;
						color: rgba(255,255,255,0.8);
						margin-top: 14rpx;
					}
				}
			}
			.box-head-content {
				width: 100%;
				padding: 40rpx 30rpx;
				box-sizing: border-box;
				background-color: #FFFFFF;
				border-radius: 20rpx;
				margin-top: 30rpx;
				.item {
					width: 100%;
					display: flex;
					flex-direction: column;
					margin-bottom: 30rpx;
					&:last-child {
						margin: 0 !important;
					}
					.item-cate {
						width: 100%;
						display: flex;
						align-items: center;
						padding: 30rpx 0;
						box-sizing: border-box;
						border-bottom: 1rpx solid #E5E5E5;
						.active {
							background: #00BC12 !important;
							color: #FFFFFF !important;
						}
						.item-cate-row {
							width: 208rpx;
							height: 72rpx;
							line-height: 72rpx;
							text-align: center;
							background: #EEEEEE;
							border-radius: 36rpx;
							margin-right: 20rpx;
							&:last-child {
								margin: 0 !important;
							}
						}
					}
					.item-label {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-weight: 500;
								font-size: 32rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 32rpx;
								color: #FF0000;
							}
						}
					}
					.item-upload {
						width: 100%;
						padding: 30rpx 0;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						justify-content: space-between;
						flex-wrap: wrap;
						.item-upload-item {
							width: 300rpx;
							margin-bottom: 40rpx;
							&:nth-child(3) {
								margin: 0 !important;
							}
							.image {
								width: 100%;
								height: 196rpx;
								background: #F7F7F7;
								border-radius: 16rpx;
								display: flex;
								align-items: center;
								justify-content: center;
								flex-direction: column;
								image {
									width: 48rpx;
									height: 48rpx;
								}
								text {
									font-weight: 400;
									font-size: 28rpx;
									color: #666666;
									margin-top: 12rpx;
								}
							}
							.info {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: center;
								margin-top: 16rpx;
								text {
									&:nth-child(1) {
										font-weight: 400;
										font-size: 26rpx;
										color: #333333;
									}
									&:nth-child(2) {
										font-weight: 400;
										font-size: 26rpx;
										color: #FF0000;
									}
								}
							}
						}
					}
					.item-val {
						width: 100%;
						padding: 30rpx 0;
						box-sizing: border-box;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: 1rpx solid #E5E5E5;
						input {
							width: 100%;
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
						text {
							font-weight: 400;
							font-size: 30rpx;
							color: #666666;
						}
						button {
							width: 100%;
							height: 100%;
							position: absolute;
							top: 0;
							left: 0;
							opacity: 0;
						}
					}
				}
			}
		}
	}
</style>
